/* istanbul ignore file */
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/index';
import React from 'react';
import { DeleteTimelineRecordButton } from 'domain/shared/timeline/button';
import useFinancialAnalyticNoteService, {
  DELETE_ASSET_NOTE_PERMISSION,
} from 'domain/finance/assets/Timeline/note/assetNoteService';
import { useShowContext } from 'framework/show';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { Collapsible, HtmlField } from 'framework/ui/field';
import { useAssetUrl, useAssetId } from 'domain/finance/assets/shared/useAssetRouting';
import useAssetService from 'domain/finance/assets/useAssetService';
import { ReplaceUrlWithLink } from 'framework/utils';

const NoteTimelineRecordLayout = ({ onEdit, ...props }: any) => {
  const { invalidateCache } = useAssetService();
  const { deleteById } = useFinancialAnalyticNoteService();
  const { data } = useShowContext();
  const id = data.getValueBySource('id');
  const timelineId = data.getValueBySource('timelineId');
  const { getTimelineUrl } = useAssetUrl();
  const assetId = useAssetId();

  const buttons = [
    <DeleteTimelineRecordButton
      permissionToCheck={DELETE_ASSET_NOTE_PERMISSION}
      deleteMethod={async (noteId: string) => {
        await deleteById(noteId);
        invalidateCache();
      }}
      key="add"
      id={id}
      timelineId={timelineId}
      entityName="note"
    />,
  ];

  return (
    <BaseTimelineRecordLayout
      timelineType={TimelineType.NOTE}
      fields={
        <Collapsible>
          <ReplaceUrlWithLink>
            <HtmlField source="content" label="" />
          </ReplaceUrlWithLink>
        </Collapsible>
      }
      buttons={buttons}
      timelineFooter={() => null}
      basePathname={getTimelineUrl(assetId)}
      {...props}
    />
  );
};

export default NoteTimelineRecordLayout;
